import React, { useState, useEffect } from 'react';
import SeoHelmet from '../components/SeoHelmet';

const Roster = () => {
  const [activeArtist, setActiveArtist] = useState('kahlo');
  const [isVisible, setIsVisible] = useState(false);

  // Define all artists with image URLs and social media links
  const artists = {
    kahlo: {
      name: 'KAH-LO',
      genre: 'DANCE • POP • ELECTRONIC',
      bio: `Recognized for her energetic style and unmatched versatility, Kah-Lo brings a vibrant blend of electronic pop, house, and Afro-inspired rhythms to the global music scene. Born and raised in Lagos, Nigeria, her major breakthrough came with her electrifying collaboration with British DJ / producer Riton on the track "Rinse & Repeat," which earned a nomination for Best Dance Recording at the Grammy Awards in 2017. She followed this success with her debut solo single "Fasta," which was named Hottest Record in the World by BBC Radio 1 in 2017.\n\nToday, Kah-Lo continues to push boundaries, redefining what modern African-influenced dance music can sound like. Bold, experimental, and globally minded, she represents a new wave of artists taking the Afro-electronic sound to fresh heights.`,
      latestRelease: 'Latest singles and collaborations (2024)',
     
      images: [
        'https://cdn.prod.website-files.com/62ee0bbe0c783a903ecc0ddb/6509f27bf31fdca9b5ab5a28_flaunt_kahlo7.webp',
        'https://images.squarespace-cdn.com/content/v1/5edf06dcd417cb4da8ba2163/1553edd6-3e93-4168-a2cf-52c9ebfbaf5f/78E227BB-6097-40FE-BBBB-90278DAAF799.jpeg',
        'https://i.scdn.co/image/ab6761610000e5eb93deea3bc5422c31109f07e2',
        'https://images.squarespace-cdn.com/content/v1/5b7631c8a2772c69ae56fe8b/42c27baa-7bd5-4190-81fa-9c873ab54e6b/Artist+Spotlight+Kah-Lo+%281%29.png'
      ],
      socials: {
        spotify: 'https://open.spotify.com/artist/59iOp415oyqGlBHyAhu4z3?si=JMtG_9nrQeiiBZhnotR3Ag',
        apple: 'https://music.apple.com/ca/artist/kah-lo/900760897',
         tiktok: 'https://www.tiktok.com/@thatkahlo',
        twitter: 'https://x.com/thatKahLo',
        facebook: 'https://www.facebook.com/thatkahlo',
        instagram: 'https://www.instagram.com/thatkahlo',
       
        youtube: 'https://youtube.com/@kah-lo',
        
      }
    },
    pheelz: {
      name: 'PHEELZ',
      genre: 'AFROBEATS • PRODUCER • R&B • POP',
      bio: `Award-winning Nigerian-born singer and producer Philip Kayode Moses, better known as Pheelz, started his music journey at the age of 10 singing in a church. In 2011, he began working at a record label where he met Nigerian music star, Olamide. This would mark his growth in the music industry.\n\nHis breakthrough came after producing chart-topping singles by Olamide off his YBNL album in 2012. After a decade producing hits for global icons including Davido, Wizkid, Usher, Fireboy DML, and Tiwa Savage, Pheelz emerged as a star artist in his own right, scoring a global smash hit with 2022's "Finesse" featuring BNXN.\n\nHe's known for his passionate, danceable blend of R&B, pop, and hip-hop.`,
      latestRelease: 'Latest singles and productions (2024)',
      
      images: [
        'https://upload.wikimedia.org/wikipedia/commons/2/2b/Pheelz_001.jpg',
        'https://www.billboard.com/wp-content/uploads/2022/04/Pheelz-cr-Osagie-Igunma-press-2022-billboard-1548.jpg',
        'https://afrobeatsmagazine.com/wp-content/uploads/2025/07/Pheelz.jpg',
        'https://cdn.prod.website-files.com/633a38706320c88f5e8c4ac8/6478c2722eb8f9e5dd18c0f5_pheelz%201.JPG'
      ],
      socials: {
        spotify: 'https://open.spotify.com/artist/5Jv1MsZBh0sqokFq7pU8Xg?si=Wzph4pmjQVOWw1yJ8wLUeA',
        apple: 'https://music.apple.com/ca/artist/pheelz/426470145',
          tiktok: 'https://www.tiktok.com/@pheelzgood',
        instagram: 'https://www.instagram.com/pheelzgood',
      
        youtube: 'https://youtube.com/@pheelz',
        facebook: 'https://www.facebook.com/pheelzonthebeat',
        twitter: 'https://x.com/Pheelz',
        
      }
    },
    chrissy: {
      name: 'CHRISSY SPRATT',
      genre: 'R&B • AMAPIANO',
      bio: `From doing covers of hit songs on TikTok to going on tour with Nigerian Afrobeats star Chike, Chrissy Spratt is a global pop star in the making. Her journey can be traced back to 2017, when she was featured in a song with Canadian rapper Peter Jackson. After the pandemic hit, she pivoted to building her own following online doing covers of popular songs.\n\nShe became a sensation when her cover of "Cough (Odo)" by Kizz Daniel hit over 19 million views on TikTok, nearly 2 million views on Instagram, and 1.7 million views on YouTube. She has since received praise from global stars, including Davido and Tiwa Savage, and garnered millions of fans, especially from Nigeria. And in August 2025, she went on tour with Chike on the "Boo of the North" Canadian tour.\n\nBorn and raised in Ottawa, Canada, with both Lebanese and Armenian heritage, Chrissy has garnered more than 6 million followers across all platforms (more than 4 million on TikTok and a million-plus each on Instagram) with her covers of predominantly Afrobeats music from Nigeria.\n\nChrissy mixes pop and R&B with other contemporary dance sounds.`,
      latestRelease: 'Debut EP "Maybe Next Time" (August 2025)',
     
      images: [
        'https://resources.tidal.com/images/ef3cd613/85a5/420d/a606/504657d56274/750x750.jpg',
        'https://yt3.googleusercontent.com/Po3MeAj8l9CQLH3AoFAaIY6H9r_lzI4jFK2ATGcI_8nhR04nQb_FUDvX0g_25DvGy1lJ5o-zQA=s900-c-k-c0x00ffffff-no-rj',
        'https://thegarnettereport.com/wp-content/uploads/2025/04/701368b9-64c7-a94e-8ddb-e886d4c6375e.jpeg',
        'https://digimillennials.com/wp-content/uploads/2025/08/IMG_9896-scaled.jpeg'
      ],
      socials: {
          spotify: 'https://open.spotify.com/artist/1dn9CnVS5B1JTPFOzjhXq6?si=zrxGD9bVQp--ihQ_1p-PpA',
        apple: 'https://music.apple.com/ca/artist/chrissy-spratt/962843981',
        tiktok: 'https://www.tiktok.com/@chrissyonair',
        instagram: 'https://www.instagram.com/chrissyspratt',
        youtube: 'https://youtube.com/@chrissysprattmusic',
        facebook: 'https://www.facebook.com/chrissyspratt',
      
      }
    },
    joeboy: {
      name: 'JOEBOY',
      genre: 'AFRO-POP • CONTEMPORARY R&B',
      bio: `Lagos-born Nigerian singer and songwriter Joeboy emerged in the Afro-pop and contemporary R&B space with a distinct gift for smooth, romantic melodies. From posting covers online, he quickly became a favorite among music lovers across Africa and beyond after the release of his breakout single "Baby."\n\nHis debut studio album "Somewhere Between Beauty & Magic," released in 2021 consolidated his position as a leading voice in the afro-pop space. By 2023, Joeboy had surpassed 2 billion global streams, marking a major milestone in his career.\n\nKnown for his smooth vocals, excellent songwriting and ability to blend Afrobeats with contemporary R&B, Joeboy has won several notable awards, including Best Artiste in African Pop at the All Africa Music Awards (AFRIMA) and Best Pop at the Soundcity MVP Awards in 2020. He continues to evolve as a global ambassador of contemporary African music.`,
      latestRelease: 'Latest singles and collaborations (2024)',
     
      images: [
        'https://images.squarespace-cdn.com/content/v1/609093abb694f42c8fba3d4e/90d5fdb4-abeb-47a8-8d0d-e6fad9efc3c9/Screenshot+2024-05-08+at+12.16.24.png',
        'https://image.okayafrica.com/184999.webp?imageId=184999&width=960&height=678&format=jpg',
        'https://www.billboard.com/wp-content/uploads/media/JoeBoy-press-by-Emily-Nkanga-bb26-2019-billboard-1548.jpg',
        'https://cdn-images.dzcdn.net/images/artist/7f560c1fe16d3eaed8b029bd1a618e9f/1900x1900-000000-80-0-0.jpg'
      ],
      socials: {
         spotify: 'https://open.spotify.com/artist/1XavfPKBpNjkOfxHINlMHF?si=K4RK5nl_TpeRoh6sEW3fJQ',
        apple: 'https://music.apple.com/ca/artist/joeboy/1202620452',
        instagram: 'https://www.instagram.com/joeboyofficial',
        twitter: 'https://x.com/Joeboy',
        facebook: 'https://www.facebook.com/iamjoeboy',
        youtube: 'https://youtube.com/@joeboy',
       
      }
    },
    siraheem: {
      name: 'SIRAHEEM',
      genre: 'AFROBEATS • POP',
      bio: `Popularly known as Siraheem, Subomi Raheem Okoya is one of Hi-Way 89's most promising rising artists. Born in Lagos, Nigeria, Siraheem has been making waves in the Afrobeats scene since his debut single "Which Type Woman" in 2022.\n\nWith an unapologetic and infectious vibe, Siraheem has continued to push through, proving his talent and passion for the game. Following his viral track "Bad Bitch Syndrome" in 2024, Siraheem gained widespread support and a fast-growing fanbase.\n\nWith his recent release "Anodabanga" gaining attention, he's constantly proving that anyone can carve out a name for themselves in the music industry, irrespective of their background.`,
      latestRelease: '"Anodabanga" (Latest Single)',
      
      images: [
        'https://topchartsafrica.com/wp-content/uploads/2025/06/IMG_6873.jpeg',
        'https://i.audiomack.com/subomiokoya/958b27ad96.webp?width=1000&height=1000',
        'https://thescoove.africa/wp-content/uploads/2024/12/siraheem-4.webp',
        'https://topchartsafrica.com/wp-content/uploads/2025/06/IMG_6857-819x1024.jpeg'
      ],
      socials: {
          spotify: 'https://open.spotify.com/artist/1FAkIUZ8pw9AncpmPhhmuh?si=2Bt67cZHR8-1S4xB_AvnRA',
        apple: 'https://music.apple.com/ca/artist/siraheem/1639254261',
           tiktok: 'https://www.tiktok.com/@siraheem7',
        instagram: 'https://www.instagram.com/siraheem',
        youtube: 'https://www.youtube.com/@SIRAHEEM',
     
        twitter: 'https://x.com/SIRAHEEM7',
      
      }
    },
  };

  const currentArtist = artists[activeArtist];

  // Artist-specific structured data
  const artistStructuredData = {
    "@context": "https://schema.org",
    "@type": "MusicGroup",
    "name": "HI-WAY 89",
    "description": "Independent Canadian record label",
    "url": "https://hiway89.com",
    "member": {
      "@type": "Person",
      "name": currentArtist.name,
      "description": currentArtist.bio.split('.')[0],
      "genre": currentArtist.genre,
      "homeLocation": {
        "@type": "Place",
        "name": currentArtist.location
      }
    }
  };

  const rosterMetadata = {
    title: `Artists Roster | ${currentArtist.name} | HI-WAY 89`,
    description: `Discover ${currentArtist.name} - ${currentArtist.genre} artist from ${currentArtist.location}. ${currentArtist.bio.split('.')[0]}.`,
    canonical: "/roster",
    structuredData: artistStructuredData
  };

  useEffect(() => {
    setIsVisible(true);
  }, []);

  // Social Media Icons Component
  const SocialIcons = ({ socials, size = "w-5 h-5" }) => (
    <div className="flex flex-wrap gap-3">
      {Object.entries(socials).map(([platform, url]) => (
        <a
          key={platform}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className={`text-gray-400 hover:text-white transition-all duration-300 transform hover:scale-110 ${size}`}
          aria-label={platform}
        >
           {platform === 'apple' && (
            <svg className="w-full h-full" fill="currentColor" viewBox="0 0 24 24">
              <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
            </svg>
          )}
          {platform === 'spotify' && (
            <svg className="w-full h-full" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-2-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/>
            </svg>
          )}
          {platform === 'instagram' && (
            <svg className="w-full h-full" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
            </svg>
          )}
          {platform === 'tiktok' && (
            <svg className="w-full h-full" fill="currentColor" viewBox="0 0 24 24">
              <path d="M19.589 6.686a4.793 4.793 0 01-3.77-4.245V2h-3.445v13.672a2.896 2.896 0 01-5.201 1.743l-.002-.001.002.001a2.895 2.895 0 113.183-4.51v-3.5a6.329 6.329 0 105.608 6.216 6.33 6.33 0 003.771-11.345z"/>
            </svg>
          )}
          {platform === 'youtube' && (
            <svg className="w-full h-full" fill="currentColor" viewBox="0 0 24 24">
              <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"/>
            </svg>
          )}
          {platform === 'twitter' && (
            <svg className="w-full h-full" fill="currentColor" viewBox="0 0 24 24">
              <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
            </svg>
          )}
          {platform === 'facebook' && (
            <svg className="w-full h-full" fill="currentColor" viewBox="0 0 24 24">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
            </svg>
          )}
         
        </a>
      ))}
    </div>
  );

  return (
    <>
      <SeoHelmet {...rosterMetadata} />

      <div className="min-h-screen bg-black text-white pt-28">
        {/* Minimal Header */}
        <div className={`container mx-auto px-6 py-12 transition-all duration-1000 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
          <div className="text-center mb-12">
            <h1 className="text-6xl md:text-8xl font-black mb-4 tracking-tighter">
              ARTISTS
            </h1>
            <div className="w-32 h-0.5 bg-white mx-auto mb-6"></div>
            <p className="text-lg text-gray-400 uppercase tracking-widest">
              HI-WAY 89 ROSTER
            </p>
          </div>

          {/* Artist Navigation - Minimal */}
          <div className="flex justify-center mb-16">
            <div className="flex flex-wrap justify-center gap-2 border-b border-gray-800 pb-2">
              {Object.keys(artists).map((artistKey) => (
                <button
                  key={artistKey}
                  onClick={() => setActiveArtist(artistKey)}
                  className={`px-4 md:px-8 py-3 font-medium text-sm tracking-widest transition-all duration-500 relative ${
                    activeArtist === artistKey
                      ? 'text-white'
                      : 'text-gray-500 hover:text-gray-300'
                  }`}
                >
                  {artists[artistKey].name}
                  {activeArtist === artistKey && (
                    <div className="absolute bottom-0 left-0 w-full h-0.5 bg-white transform -translate-y-2"></div>
                  )}
                </button>
              ))}
            </div>
          </div>

          {/* Artist Showcase - Split Screen Style */}
          <div className="max-w-8xl mx-auto">
            <div className="grid grid-cols-1 xl:grid-cols-12 gap-8 items-start">
              {/* Left - Visual Section */}
              <div className="xl:col-span-7 space-y-6">
                {/* Main Hero Image */}
                <div className="relative group overflow-hidden">
                  <div className="aspect-[4/5] overflow-hidden">
                    <img
                      src={currentArtist.images[0]}
                      alt={currentArtist.name}
                      className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
                    />
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                  <div className="absolute bottom-6 left-6">
                    <h2 className="text-4xl md:text-5xl lg:text-6xl font-black mb-2 tracking-tight">
                      {currentArtist.name.split(' ')[0]}
                    </h2>
                    <p className="text-lg md:text-xl text-gray-300">
                      {currentArtist.name.split(' ').slice(1).join(' ')}
                    </p>
                  </div>
                </div>

                {/* Secondary Images */}
                <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                  {currentArtist.images.slice(1, 4).map((image, index) => (
                    <div
                      key={index}
                      className="aspect-square overflow-hidden group cursor-pointer"
                    >
                      <img
                        src={image}
                        alt={`${currentArtist.name} ${index + 2}`}
                        className="w-full h-full object-cover transform group-hover:scale-110 transition-all duration-500"
                        onError={(e) => {
                          e.target.src = `https://images.unsplash.com/photo-1511379938547-c1f69419868d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80`;
                        }}
                      />
                    </div>
                  ))}
                </div>
              </div>

              {/* Right - Content Section */}
              <div className="xl:col-span-5 space-y-8">
                {/* Quick Info */}
                <div className="space-y-4">
                  <div className="flex flex-wrap items-center gap-4 text-sm text-gray-400 uppercase tracking-widest">
                   
                   
                    <span>{currentArtist.genre}</span>
                  </div>
                  <SocialIcons socials={currentArtist.socials} size="w-6 h-6" />
                </div>

               

                {/* Latest Release */}
                <div className="bg-gray-900/50 p-6 border-l-4 border-white">
                  <h3 className="text-sm uppercase tracking-widest text-gray-400 mb-2">LATEST RELEASE</h3>
                  <p className="text-lg font-medium">{currentArtist.latestRelease}</p>
                </div>

                {/* Bio */}
                <div className="space-y-6">
                  <h3 className="text-2xl font-black border-l-4 border-white pl-4">ARTIST PROFILE</h3>
                  <div className="text-gray-300 leading-relaxed space-y-4 text-base md:text-lg">
                    {currentArtist.bio.split('\n\n').map((paragraph, index) => (
                      <p key={index} className="leading-6 md:leading-7">{paragraph}</p>
                    ))}
                  </div>
                </div>

                {/* CTA Buttons - Modern */}
                <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4 pt-8">
                  <a
                    href={currentArtist.socials.spotify}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex-1 bg-white text-black font-bold py-4 px-8 hover:bg-gray-100 transition-all duration-300 transform hover:scale-105 text-sm tracking-widest text-center"
                  >
                    STREAM MUSIC
                  </a>
                  <a
                    href={currentArtist.socials.instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex-1 border border-white text-white font-bold py-4 px-8 hover:bg-white hover:text-black transition-all duration-300 text-sm tracking-widest text-center"
                  >
                    FOLLOW ARTIST
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Full Width Gallery */}
          {currentArtist.images.length > 4 && (
            <div className="mt-24">
              <div className="border-t border-gray-800 pt-12">
                <h3 className="text-2xl font-black mb-8 text-center uppercase tracking-widest">VISUAL GALLERY</h3>
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                  {currentArtist.images.slice(4).map((image, index) => (
                    <div
                      key={index}
                      className="group relative overflow-hidden aspect-square cursor-pointer"
                    >
                      <img
                        src={image}
                        alt={`${currentArtist.name} gallery ${index + 5}`}
                        className="w-full h-full object-cover transform group-hover:scale-110 transition-all duration-700"
                        onError={(e) => {
                          e.target.src = `https://images.unsplash.com/photo-1511379938547-c1f69419868d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80`;
                        }}
                      />
                      <div className="absolute inset-0 bg-black opacity-0 group-hover:opacity-10 transition-opacity duration-300"></div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Artist Switch Footer */}
          <div className="mt-20 text-center">
            <div className="inline-flex flex-col md:flex-row items-center space-y-4 md:space-y-0 md:space-x-8 text-gray-400">
              <span className="text-sm uppercase tracking-widest">VIEW ARTIST</span>
              <div className="flex flex-wrap justify-center gap-4">
                {Object.keys(artists).map((artistKey) => (
                  <button
                    key={artistKey}
                    onClick={() => setActiveArtist(artistKey)}
                    className={`text-lg font-medium transition-all duration-300 ${
                      activeArtist === artistKey
                        ? 'text-white scale-110'
                        : 'text-gray-500 hover:text-gray-300'
                    }`}
                  >
                    {artists[artistKey].name.split(' ')[0]}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Roster;